import { Card, Pagination, Space, Table } from "antd";
import moment from "moment-jalaali";
import React, { useEffect, useState } from "react";
import strings from "../../utils/strings";
import { useNavigate } from "react-router-dom";
import UserServices from "../../services/UserServices";
import { usePersistedStore } from "../../store/persisted-store";
import EditMarketer from "./EditMarketer";
import { useGeneralStore } from "../../store/slices/createGeneralSlice";

const columns = (
  sortDirection,
  set_sortDirection,
  set_member,
  marketersList,
  setSelectedMarketer,
  setShowModal,
  provinces
) => [
    {
      title: "نام کاربر",
      dataIndex: "FullName",
      key: "FullName",
      ellipsis: true,
      width: 120,

      render: (text) => <span style={{ color: "#5ec393" }}>{text}</span>,
    },
    {
      title: "نام کاربری",
      dataIndex: "Username",
      key: "Username",
      width: 110,
    },
    {
      title: "تاریخ درخواست",
      dataIndex: "CreationTime",
      key: "CreationTime",
      width: 120,
      render: (data) =>
        data &&
        strings.getFarsiNum(moment(data).format(" jYYYY/jMM/jDD  ساعت:  HH:mm ")),
    },
    {
      title: "تاریخ تایید درخواست",
      dataIndex: "ConfirmCreationTime",
      key: "ConfirmCreationTime",
      width: 120,
      render: (data) =>
        data &&
        strings.getFarsiNum(moment(data).format(" jYYYY/jMM/jDD  ساعت:  HH:mm ")),
    },
    {
      title: "شهر",
      dataIndex: "CityName",
      key: "CityName",
      width: 120,
    },

    {
      title: "شغل",
      dataIndex: "JobTitle",
      key: "JobTitle",
      width: 120,

    },
    // {
    //   title: "شماره پرسنلی",
    //   dataIndex: "PersonId",
    //   key: "PersonId",
    //   width: 120,

    // },

    {
      title: "",
      dataIndex: "operation",
      key: "operation",
      ellipsis: true,
      width: 100,
      render: (_, record) => {
        return (
          marketersList.length >= 1 && (
            <Space size="middle">
              <button
                type="dashed"
                className="btn btn-warning btn-sm waves-effect waves-light"
                onClick={() => {
                  //   editOneUser(record.MarketersList)
                  setShowModal(true)
                  setSelectedMarketer(record);
                  //   if (!roleList?.length) {
                  //       getBusinessRole()
                  //   }
                }}
              >
                <i className="far fa-edit font-size-16 align-middle mr-2"></i>{" "}
                ویرایش
              </button>
            </Space>
          )
        );
      },
    },
  ];

const MarketersList = () => {
  const general = useGeneralStore();
  const [member, set_member] = useState("");
  const [selectedMarketer, setSelectedMarketer] = useState(null);
  const [search, setSearch] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [sortDirection, set_sortDirection] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [filteredInfo, setFilteredInfo] = useState([]);
  const [saveEdit, setSaveEdit] = useState(false);
  const navigate = useNavigate();

  const {
    auth,
    business,
    marketers,
    FILTERED_ITEM,
    FILTER_Marketers,
    GET_ALL_Marketers,
    GET_SINGLE_Marketer,
    Marketers_LOADING,
    SET_TOTAL_Marketers,
  } = usePersistedStore();

  const pageSize = 10;
  const initLoading = marketers.loading;
  const marketersList = marketers.filtered;
  const TotalUsers = marketers.totalMarketers;
  const marketersData = marketers.data;
  const currentBusiness = business.currentBusiness;
  const marketerSystem = currentBusiness?.data?.marketerSystem;
  const provinces = general.provinces.data.Provinces;
  const roleList = business.businesses.roles.Roles;
  const userInfoResources = auth.userInfo.Resources;
  // const { token } = currentBusiness;
  const token = auth?.userToken;
  const businessToken = auth?.userInfo?.BusinessToken;

  useEffect(() => {
    if (!token) navigate("/dashboard");

    getMarketersList();
    // (getProvinces());
  }, [navigate, token, pageNumber]);

  useEffect(() => {
    if (sortDirection !== "" || member !== "") getMarketersList();
  }, [sortDirection, member]);

  const handleChange = (pagination, filters, sorter, extra) => {
    setFilteredInfo(filters.RoleIds);
  };

  const pageChange = (e) => {
    navigate.push(`/dashboard/marketers-list/${e}`);
  };

  function getMarketersList() {
    Marketers_LOADING(true);
    if (token)
      UserServices.getMarketersList(token, businessToken, {
        sorts: [
          {
            Member: member,
            SortDirection: sortDirection,
          },
        ],
        page: pageNumber,
        pageSize: pageSize,
        filters: null,
        groups: null,
        aggregates: null,
      })
        .then((res) => {
          GET_ALL_Marketers(res.data.Marketers);
          SET_TOTAL_Marketers(res.data.Total);
          Marketers_LOADING(false);
        })
        .catch((error) => {
          Marketers_LOADING(false);
        });
  }

  const closeModal = () => {
    setSelectedMarketer(null)
  }

  return (
    <div>
      <Card>
        <Table

          style={{ overflowX: "scroll" }}
          className="custom-table"
          bordered
          rowKey="PersonId"
          columns={columns(
            sortDirection,
            set_sortDirection,
            set_member,
            marketersList,
            setSelectedMarketer,
            setShowModal,
            provinces
          )}
          loading={initLoading}

          dataSource={
            search === false ? [...marketersData] : [...marketersList]
          }
          onChange={handleChange}
          scroll={true}
          pagination={false}
        />
        <Pagination
          onChange={pageChange}
          total={TotalUsers}
          pageSize={pageSize}
          showSizeChanger={false}
          defaultCurrent={pageNumber}
        />
        {
          selectedMarketer &&
          <EditMarketer
            showModal={showModal}
            getMarketersList={getMarketersList}
            setShowModal={setShowModal}
            closeModal={closeModal}
            selectedMarketer={selectedMarketer}
            setSelectedMarketer={setSelectedMarketer}
          />
        }
      </Card>
    </div>
  );
};

export default MarketersList;
